import { useEffect, useState } from 'react';
import type { UseClipboardResult } from './types';

function useClipboard(): UseClipboardResult {
  const [canWrite, setCanWrite] = useState(false);

  useEffect(() => {
    if (!navigator.permissions) return;
    navigator.permissions
      // 'clipboard-write' is a real Permissions API value (see "Security considerations" at
      // https://developer.mozilla.org/en-US/docs/Web/API/Clipboard_API), but TypeScript's
      // lib.dom `PermissionName` union doesn't include the Clipboard API's permissions.
      .query({ name: 'clipboard-write' as PermissionName })
      .then(result => {
        setCanWrite(['granted', 'prompt'].includes(result.state));
      })
      .catch(() => setCanWrite(false));
  }, []);

  return {
    canWrite,
    async write(text: string) {
      await navigator.clipboard.writeText(text);
    },
  };
}

export default useClipboard;
